import { useEffect, useState } from "react";
import { fetchEnrollmentsStats } from "../../service/AdminService/enrollmentService";
import { message } from "antd";

import totalEnrollments from "../../assets/icons/dashboard/Total Enrollments.svg";
import totalCurriculum from "../../assets/icons/dashboard/TotalCurriculum.svg";
import TotalUsers from "../../assets/icons/dashboard/TotalUsers.svg";
import TotalCourse from "../../assets/icons/dashboard/TotalCourse.svg";
import completionRate from "../../assets/icons/CompletionRate.svg";
import group from "../../assets/icons/dashboard/TotalGroups.svg"

export const useStats = () => {
  const [statsLoading, setStatsLoading] = useState(false);
  const [stats, setStats] = useState([]);

  const getStats = async () => {
    setStatsLoading(true);

    const response = await fetchEnrollmentsStats();

    if (response.success) {
      const data = response?.data;

      const formatted = [
        {
          label: "Total Enrollments",
          value: data.totalEnrollments,
          icon: totalEnrollments,
        },
        {
          label: "Recent Enrollments",
          value: data.recentEnrollments,
          icon: completionRate,
        },
        {
          label: "Users Enrolled",
          value: data.usersEnrolled,
          icon: TotalUsers,
        },
        {
          label: "Groups Enrolled",
          value: data.groupsEnrolled,
          icon: group,
        },
        {
          label: "Courses Enrolled",
          value: data.coursesEnrolled,
          icon: TotalCourse,
        },
        {
          label: "Bundles Enrolled",
          value: data.bundlesEnrolled,
          icon: totalCurriculum,
        },
      ];

      setStats(formatted);
    } else {
      message.error(response.message);
    }

    setStatsLoading(false);
  };

  useEffect(() => {
    getStats();
  }, []);

  return {
    stats,
    statsLoading,
  };
};
